import { FormatAndLinkify as format } from '@99designs/ninedown';
import * as React from 'react';
interface Props {
    rawHtml: string;
}

export const formatAndLinkify = (rawHtml: string) => {
    return rawHtml === null || rawHtml === '' ? '' : <FormatAndLinkify rawHtml={rawHtml} />;
};

const FormatAndLinkify = (props: Props) => {
    const { rawHtml } = props;

    const createMarkUp = (input: string) => {
        return { __html: format(input, window.location.hostname) };
    };

    return <div dangerouslySetInnerHTML={createMarkUp(rawHtml)} />;
};

export default FormatAndLinkify;
